import { Grid } from "@mui/material";
import LocationInformation from "./summary/1.LocationInformation";
import PropertyInfo from "./summary/2.PropertyInfo";
import PremiumEstimate from "./summary/3.PremiumEstimate";
import ReplacementCost from "./summary/4.ReplacementCost";
import RiskInfo from "./summary/5.RiskInfo";
import FireStations from "./summary/6.FireStations";
import CensusData from "./summary/7.CensusData";
import LoanLenderInfo from "./summary/8.LoanLenderInfo";
import FinancialMetrics from "./summary/9.FinancialMetrics";
import GreatSchools from "./summary/10.GreatSchools";
import Features from "./summary/11.Features";
import Amenities from "./summary/12.Amenities";
import OwnerData from "./summary/13.OwnerData";
import Taxes from "./summary/14.Taxes";
import Description from "./summary/15.Description";
import Structures from "./summary/16.Structures";

export default function Dashboard(props) {
  const items = [
    [{ component: LocationInformation, props: { xs: 12 } }],
    [{ component: PropertyInfo, props: { lg: 8, xs: 12 } }],
    [
      { component: PremiumEstimate, props: { lg: 4, xs: 12 } },
      { component: ReplacementCost, props: { lg: 4, xs: 12 } },
    ],
    [{ component: RiskInfo, props: { lg: 4, xs: 12 } }],
    [
      { component: FireStations, props: { lg: 8, xs: 12 } },
      { component: CensusData, props: { lg: 4, xs: 12 } },
    ],
    [{ component: LoanLenderInfo, props: { lg: 6, xs: 12 } }],
    [{ component: FinancialMetrics, props: { lg: 6, xs: 12 } }],
    [{ component: GreatSchools, props: { xs: 12 } }],
    [{ component: Features, props: { lg: 6, xs: 12 } }],
    [{ component: Amenities, props: { lg: 6, xs: 12 } }],
    [{ component: OwnerData, props: { lg: 6, xs: 12 } }],
    [{ component: Taxes, props: { lg: 6, xs: 12 } }],
    [{ component: Description, props: { xs: 12 } }],
    [{ component: Structures, props: { xs: 12 } }],
  ];
  return (
    <Grid container spacing={2}>
      {items.map((item, index) => (
        <Grid item {...item[0].props} key={index}>
          {item.map((i, itemIndex) => (
            <div
              style={{
                marginTop: item.length > 1 ? (itemIndex > 0 ? 16 : 0) : 0,
              }}
              key={"item-" + itemIndex}
            >
              <i.component {...props} />
            </div>
          ))}
        </Grid>
      ))}
    </Grid>
  );
}
